import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { AuthConstants } from '../constants/auth';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
	constructor(private http: HttpClient, private storageService: StorageService) {}

	getTokenHeader() {

		if (this.storageService.get(AuthConstants.TOKEN)) {
			return {
  			    headers: new HttpHeaders({
  			      'X-BS-Auth-UserToken':this.storageService.get(AuthConstants.TOKEN)
  			    })
  			};
  		}

  		return {};
	}

	get(serviceName: string, headers?: any) {
		const url = environment.API + serviceName;
		const options = this.getTokenHeader();

		return this.http.get(url, ( headers ? headers : options));
	}

	post(serviceName: string, data: any) {
		const url = environment.API + serviceName;
		const options2 = this.getTokenHeader();

		return this.http.post(url, JSON.stringify(data), options2);
	}

	put(serviceName: string, data: any) {
		const url = environment.API + serviceName;
		const options2 = this.getTokenHeader();

		return this.http.put(url, JSON.stringify(data), options2);
	}
}